// @ts-nocheck
import React from 'react';
import ReactDOM from 'react-dom';
import { useIntl } from 'react-intl';
import { CustomThemeProvider, Prompt, usePortal } from 'sonata-react-components';

type Props = {
  id: string;
  onClose: () => void;
  onConfirm: () => void;
};

function DeleteTemplatePromt({ id, onClose, onConfirm }: Props) {
  const { formatMessage } = useIntl();
  const targetBodyPrompt = usePortal('deleteReportTemplatePrompt');

  const promptButtons = [
    {
      onClick: onConfirm,
      text: formatMessage({
        defaultMessage: 'Accept',
        id: 'common.accept'
      }),
      type: 'primary'
    }
  ];

  return ReactDOM.createPortal(
    <CustomThemeProvider themeContrast="light">
      <Prompt
        buttons={promptButtons}
        closePrompt={onClose}
        description={formatMessage({
          defaultMessage:
            'Deleting this template will make you have to configure a new one with the same settings to use it.',
          id: 'reporting.reportingDownload.deletePrompt.description'
        })}
        icon="fas fa-exclamation-triangle"
        id={`${id}-DeleteTemplatePromt`}
        title={formatMessage({
          defaultMessage: 'Are you sure you want to delete this template?',
          id: 'reporting.reportingDownload.deletePrompt.title'
        })}
      />
    </CustomThemeProvider>,
    targetBodyPrompt
  );
}

export default DeleteTemplatePromt;
